<template>
  <q-card
    tabindex="0"
    ref="cardRootRef"
    class="inhdialog-container"
    @click="$refs.acc_menu && $refs.acc_menu.hide()"
  >
    <div class="inhdialog-header">
      <h1 class="dialog_name">
        {{ isEditMode ? $t('information_about')+" " : $t('adding')+" " }}
        {{
          isEditMode
            ? (isIncome ? $t('in_receipt_loc') : isExpense ? $t('in_expenditure_loc') : $t('in_transfer_loc')) +
              " " +
              theModel.VendorCode
            : isIncome
            ? $t('of_receipt')
            : isExpense
            ? $t('of_expenditure')
            : $t('of_transfer')
        }}
      </h1>
      <app-icon
        name="close"
        width="18px"
        color="#979797"
        hover-color="#499259"
        cursor="pointer"
        :title="$t('close_esc_label')"
        @click="close"
      />
    </div>

    <div class="dialog_content">
      <!-- Пока данные загружаются -->
      <div v-if="dataLoading" class="loading-container q-mt-sm">
        <div v-for="n in 8" :key="n" class="field-group">
          <div class="field-group__row no-wrap justify-left">
            <!-- Жирный заголовок (короткая широкая полоска) -->
            <div class="skeleton skeleton-title"></div>

            <!-- Текстовый спан (длинная полоска) -->
            <div
              class="skeleton skeleton-text"
              :class="{
                'skeleton-text-short': n % 3 === 0,
                'skeleton-text-medium': n % 3 === 1,
              }"
            ></div>
          </div>
        </div>
      </div>

      <div v-else class="inner_container">
        <!-- Откуда / Куда -->
        <div class="field-group q-mt-sm">
          <div class="field-group__row no-wrap justify-left">
            <div v-if="isExpense || isTransfer" class="bold-name mr-xs">
              {{ $t('from') }}:
            </div>
            <span
              v-if="(isExpense || isTransfer) && isEditMode && !isEditing"
              >{{
                storageOptions.find((el) => el.value === theModel.from)?.label
              }}</span
            >
            <q-select
              v-else-if="
                (isExpense || isTransfer) && (!isEditMode || isEditing)
              "
              flat
              v-model="theModel.from"
              style="min-width: 150px"
              class="thin-input q-mr-xs"
              dropdown-icon="expand_more"
              fill-input
              :bottom-slots="false"
              dense
              outlined
              input-debounce="500"
              emit-value
              map-options
              :options="storageOptions"
              ref="from_select"
              @update:model-value="confirmStorage"
              @popup-hide="
                () => {
                  searchText = '';
                }
              "
              popup-content-class="my-sticky-select-menu"
            >
              <template v-slot:option="scope">
                <q-item v-bind="scope.itemProps" @click="confirmStorage">
                  <q-item-section>
                    <q-item-label>{{ scope.opt.label }}</q-item-label>
                  </q-item-section>
                </q-item>
              </template>
              <!-- Слот перед списком опций -->
              <template v-slot:before-options>
                <div class="search-sticky-container q-pa-xs bg-white">
                  <q-input
                    outlined
                    dense
                    ref="from_search_input"
                    color="white"
                    class="thin-input q-my-auto"
                    v-model="searchText"
                    hide-bottom-space
                    clearable
                    autofocus
                    :clear-icon="clearIconName"
                    :placeholder="$t('search_label')"
                    debounce="300"
                    @clear="searchText = ''"
                  >
                    <template v-slot:append>
                      <q-icon name="search" color="accent" />
                    </template>
                  </q-input>
                </div>
              </template>
              <template v-slot:no-option>
                <!-- Повторяем поле поиска здесь, иначе оно исчезнет вместе с before-options -->
                <div class="q-pa-xs bg-white">
                  <q-input
                    outlined
                    dense
                    ref="from_search_input"
                    color="white"
                    class="thin-input q-my-auto"
                    v-model="searchText"
                    hide-bottom-space
                    clearable
                    autofocus
                    :clear-icon="clearIconName"
                    :placeholder="$t('search_label')"
                    debounce="300"
                    @clear="searchText = ''"
                  >
                    <template v-slot:append>
                      <q-icon name="search" color="accent" />
                    </template>
                  </q-input>
                  <div class="text-grey q-pa-md text-center">
                    {{ $t('nothing_found') }}
                  </div>
                </div>
              </template>
            </q-select>
            <q-btn
              v-if="!isStorageConfirmed"
              no-caps
              :label="$t('select_warehouse')"
              flat
              @click="confirmStorage"
            />
            <div
              v-if="isIncome || isTransfer"
              v-show="isStorageConfirmed"
              class="bold-name mr-xs"
            >
              {{ $t('to_upper') }}:
            </div>
            <span v-if="(isIncome || isTransfer) && isEditMode && !isEditing">{{
              storageOptions.find((el) => el.value === theModel.to)?.label
            }}</span>
            <q-select
              v-show="isStorageConfirmed"
              v-if="(isIncome || isTransfer) && (!isEditMode || isEditing)"
              flat
              v-model="theModel.to"
              class="thin-input"
              dropdown-icon="expand_more"
              fill-input
              :bottom-slots="false"
              dense
              outlined
              input-debounce="500"
              emit-value
              map-options
              ref="to_select"
              style="min-width: 150px"
              :options="storageOptions"
              @popup-hide="
                () => {
                  searchText = '';
                }
              "
              popup-content-class="my-sticky-select-menu"
            >
              <!-- Слот перед списком опций -->
              <template v-slot:before-options>
                <div class="search-sticky-container q-pa-xs bg-white">
                  <q-input
                    outlined
                    dense
                    ref="from_search_input"
                    color="white"
                    class="thin-input q-my-auto"
                    v-model="searchText"
                    autofocus
                    hide-bottom-space
                    clearable
                    :clear-icon="clearIconName"
                    :placeholder="$t('search_label')"
                    debounce="300"
                    @clear="searchText = ''"
                  >
                    <template v-slot:append>
                      <q-icon name="search" color="accent" />
                    </template>
                  </q-input>
                </div>
              </template>
              <template v-slot:no-option>
                <!-- Повторяем поле поиска здесь, иначе оно исчезнет вместе с before-options -->
                <div class="q-pa-xs bg-white">
                  <q-input
                    outlined
                    dense
                    ref="from_search_input"
                    color="white"
                    class="thin-input q-my-auto"
                    v-model="searchText"
                    hide-bottom-space
                    clearable
                    autofocus
                    :clear-icon="clearIconName"
                    :placeholder="$t('search_label')"
                    debounce="300"
                    @clear="searchText = ''"
                  >
                    <template v-slot:append>
                      <q-icon name="search" color="accent" />
                    </template>
                  </q-input>
                  <div class="text-grey q-pa-md text-center">
                    {{ $t('nothing_found') }}
                  </div>
                </div>
              </template>
            </q-select>
          </div>
        </div>

        <div class="main-display-container" v-show="isStorageConfirmed">
          <!-- Проекты -->
          <div class="field-group">
            <div class="field-group__row">
              <div class="bold-name">{{ isIncome ? $t('projects_label') : $t('project_label') }}</div>
              <q-btn
                @click.stop="projectMenuVisible = !projectMenuVisible"
                v-show="existingMovementId ? (CanWrite && (isIncome || !theModel.projects.length)) : ((!isEditMode || isEditing) && (isIncome || !theModel.projects.length))"
                ref="projectMenuTrigger"
                dense
                flat
                size="md"
                class="q-pa-none"
              >
                <app-icon
                  name="plus"
                  width="18px"
                  color="#979797"
                  hover-color="#499259"
                  cursor="pointer"
                />
              </q-btn>
              <selector-popup
                v-model:visible="projectMenuVisible"
                :trigger-el="$refs.projectMenuTrigger"
                :default-width="300"
              >
                <aux-selector
                  :model-type="19"
                  :input-index="0"
                  :allow-multiple="false"
                  :model-value="theModel.projects"
                  :limit-height-to-container="true"
                  @update:modelValue="onProjectsUpdate"
                  @selectorClosed="projectMenuVisible = false"
                />
              </selector-popup>
            </div>
            <div v-for="(p, idx) in theModel.projects" :key="p.id">
              <project-row
                class="q-mb-xs"
                :el="p"
                :hide-remove-btn="existingMovementId ? !CanWrite : (isEditMode && !isEditing)"
                @detach="removeProject(idx)"
              />
            </div>
            <div class="field-group__row no-wrap justify-left">
              <q-btn
                v-if="isTransfer && isEditMode && theModel.projects?.length && !readOnly"
                no-caps
                :label="$t('create_expenditure')"
                flat
                @click="returnFromProject(1)"
              />
              <q-btn
                v-if="isTransfer && isEditMode && theModel.projects?.length && !readOnly"
                no-caps
                :label="$t('create_transfer')"
                flat
                @click="returnFromProject(2)"
              />
            </div>
            <q-dialog
              v-model="createMovementMode"
              persistent
              no-shake
              :full-width="true"
            >
              <movement-create-component
                :create-type="createMoveType"
                @close="createMovementMode = false"
                :source-model="returnReceiptModel"
              />
            </q-dialog>
          </div>

          <!-- Счета -->
          <div class="field-group">
            <div class="field-group__row">
              <div class="bold-name">{{ $t('bills') }}</div>
              <q-btn
                @click.stop
                v-show="!isEditMode || isEditing"
                dense
                flat
                size="md"
                class="q-pa-none"
              >
                <app-icon
                  name="plus"
                  width="18px"
                  color="#979797"
                  hover-color="#499259"
                  cursor="pointer"
                />
                <q-menu
                  max-height="1300px"
                  ref="acc_menu"
                  anchor="center right"
                  self="center left"
                  style="overflow: hidden"
                  @keydown.esc.exact="$refs.acc_menu && $refs.acc_menu.hide()"
                  persistent
                  no-shake
                >
                  <q-tabs
                    v-model="accounts_tab"
                    v-if="isIncome"
                    dense
                    class="text-grey bg-white"
                    active-color="dark"
                    indicator-color="accent"
                    align="justify"
                  >
                    <q-tab
                      name="account_selector"
                      no-caps
                      :label="$t('invoices_payments_unattached')"
                    />
                    <q-tab
                      name="new_payment"
                      no-caps
                      :label="$t('add_payment')"
                    />
                  </q-tabs>
                  <q-tab-panels
                    v-model="accounts_tab"
                    animated
                    class="full-height bg-white"
                    style="overflow: hidden"
                  >
                    <q-tab-panel
                      name="account_selector"
                      class="bg-white full-height q-pa-xs"
                      style="overflow: hidden"
                    >
                      <aux-selector
                        class="movement-accounts-selector"
                        :model-type="!existingMovementId ? 18 : 26"
                        :set-id="existingMovementId"
                        :input-index="0"
                        :hide-close-button="true"
                        v-model="tmp_selected_account"
                        :allow-multiple="false"
                        @selectorClosed="
                          $refs.acc_menu && $refs.acc_menu.hide()
                        "
                      />
                    </q-tab-panel>
                    <q-tab-panel
                      v-if="isIncome"
                      name="new_payment"
                      class="bg-white full-height q-pa-none q-pb-sm"
                      style="overflow: hidden"
                    >
                      <payment-create-component v-model="newPayment" />
                      <div class="row no-wrap justify-end q-mt-sm q-mr-md">
                        <q-btn
                          no-caps
                          :label="$t('attach')"
                          color="primary"
                          :disable="
                            !newPayment.paymentNumber.length ||
                            newPayment.paymentAmount <= 0 ||
                            !newPayment.currencyName.length
                          "
                          @click.stop="addNewPayment"
                        />
                      </div>
                    </q-tab-panel>
                  </q-tab-panels>
                </q-menu>
              </q-btn>
            </div>
            <connections-table-html
              v-if="entity_store.accounts?.length"
              v-model="entity_store.accounts"
              @removeItem="removeConnection"
              :check-sums="false"
              :show-sums="isIncome"
              :hide-remove-btn="isEditMode && !isEditing"
              :show-lock-status="true"
              :read-only="readOnly"
            />
          </div>

          <div class="field-group" v-if="tmp_payments?.length && isIncome">
            <div class="bold-name flex items-center">{{ $t('payments') }}:</div>
            <div class="file-list">
              <connections-table-html
                :model-value="tmp_payments"
                :check-sums="false"
                :show-sums="false"
                @removeItem="removePayment"
                :hide-remove-btn="false"
                :read-only="readOnly"
              />
            </div>
          </div>

          <!-- Файлы -->
          <div class="field-group">
            <div class="bold-name flex items-center">
              {{ $t('files') }}
              <div class="file-button q-ml-md">
                <input
                  ref="fileInputStorage"
                  type="file"
                  multiple
                  hidden
                  @change="attachFileForMovementAdd"
                />
                <q-icon
                  v-if="!isEditMode || isEditing"
                  :name="fileIconName"
                  size="xs"
                  color="accent"
                  class="pointer hover-green"
                  :title="$t('attach_files')"
                  @click="chooseAndUploadFile"
                />
              </div>
            </div>
            <div class="file-list">
              <!-- 1. Уже привязанные файлы (с сервера) -->
              <div
                v-for="(file, index) in attachedFiles"
                :key="index"
                class="file-item"
              >
                <span
                  class="file_container"
                  :title="$t('upload_file')"
                  @click.stop="DownloadFile(file, $event)"
                >
                  {{ file.Name }}
                </span>
                <app-icon
                  v-if="!isEditMode || isEditing"
                  name="delete-outline"
                  width="18px"
                  color="#979797"
                  hover-color="#499259"
                  cursor="pointer"
                  :title="$t('remove')"
                  @click="deleFileFromMovementAdd(file.Id)"
                />
              </div>

              <!-- 2. Новые файлы (из буфера) -->
              <div
                v-for="item in pendingFiles"
                :key="item.tempId"
                class="file-item"
              >
                <span class="pending"> {{ item.name }} ({{ $t('prepared') }}) </span>
                <app-icon
                  name="delete-outline"
                  width="18px"
                  color="#979797"
                  hover-color="#499259"
                  cursor="pointer"
                  :title="$t('remove')"
                  @click="removePending(item.tempId)"
                />
              </div>
            </div>
          </div>

          <div class="field-group q-mt-sm">
            <!-- Комментарий + Добавить позицию -->
            <div class="field-group__row">
              <div class="field-group__col">
                <div class="flex items-center" style="flex-wrap: nowrap">
                  <div class="bold-name">{{ $t('details_type') }}:</div>
                  <span
                    v-if="canEditMovementComment && (!isEditMode || isEditing)"
                    class="comment-tpl-trigger q-ml-sm"
                    style="align-self: start"
                    @click.stop
                  >
                    <app-icon
                      name="comment-template"
                      width="18px"
                      color="#979797"
                      hover-color="#499259"
                      cursor="pointer"
                      :title="$t('info_templates')"
                    />
                    <q-menu
                      v-if="canEditMovementComment && (!isEditMode || isEditing)"
                      max-height="1300px"
                      ref="comment_template_menu"
                      anchor="center right"
                      self="center left"
                    >
                      <aux-selector
                        :model-type="25"
                        :input-index="0"
                        :allow-multiple="false"
                        :allow-free-input="true"
                        @deleteItem="deleteCommentTemplate"
                        v-model="comment_templates"
                        @input-value="
                          (val) => {
                            addCommentTemplate(val);
                          }
                        "
                        @selectorClosed="
                          $refs.comment_template_menu &&
                            $refs.comment_template_menu.hide()
                        "
                      />
                    </q-menu>
                  </span>
                </div>
                <div
                  v-if="isEditMode && !isEditing && existingMovementComment"
                  class="movement-comment-existing q-mb-xs"
                >
                  {{ existingMovementComment }}
                </div>
                <native-input
                  v-if="!isEditMode || isEditing"
                  ref="comment_field"
                  style="width: -moz-available; width: -webkit-fill-available"
                  :show-border="canEditMovementComment && (!isEditMode || isEditing)"
                  :model-value="currentCommentValue"
                  :edit-on-click="true"
                  :disabled-field="!canEditMovementComment || (isEditMode && !isEditing)"
                  @update:caretPosition="onCaretPositionChange"
                  @click="onNativeInputClick"
                  @blur="onCommentBlur"
                  @update:modelValue="
                    (newname) => {
                      setCommentValue(newname);
                    }
                  "
                />
              </div>
              <div class="field-group__colsmall">
                <div class="summary">
                  <div
                    v-if="
                      isIncome &&
                      !(canCreateWithoutBills && accountsTotal === 0)
                    "
                    class="summary__label"
                  >
                    {{ $t('amount_by_invoices') }}:&nbsp;
                  </div>
                  <div class="summary__label">{{ $t('amount_by_positions') }}:&nbsp;</div>
                  <div
                    v-if="
                      isIncome &&
                      !(canCreateWithoutBills && accountsTotal === 0)
                    "
                    class="summary__hint"
                  >
                    ({{ $t('must_be_equal') }})
                  </div>
                </div>
                <div class="summary">
                  <div
                    v-if="
                      isIncome &&
                      !(canCreateWithoutBills && accountsTotal === 0)
                    "
                    :class="[
                      'summary__label',
                      { 'green-text': sumsEqualForCreation },
                    ]"
                  >
                    {{ money(accountsTotal) }}
                  </div>
                  <div
                    :class="[
                      'summary__label',
                      {
                        'green-text':
                          isIncome &&
                          !(canCreateWithoutBills && accountsTotal === 0) &&
                          sumsEqualForCreation,
                      },
                    ]"
                  >
                    {{ money(positionsTotal) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!isEditMode" class="field-group q-mt-sm">
            <!-- Добавить позицию -->
            <div class="bold-name">{{ $t('add_position') }}</div>
            <div class="row no-wrap items-start">
              <template v-if="currentPosId > 0">
                <app-icon
                  class="q-mr-xs add-pos-info"
                  name="info-circle-outline"
                  width="18px"
                  color="#979797"
                  hover-color="#499259"
                  cursor="pointer"
                  :title="$t('info')"
                  @click="showPosInfoMode = true"
                />
                <q-dialog
                  v-model="showPosInfoMode"
                  no-shake
                  :full-width="!isMobile"
                  :maximized="isMobile"
                >
                  <item-addition-component
                    :existing-position-id="currentPosId"
                    @close="showPosInfoMode = false"
                  />
                </q-dialog>
              </template>
              <div class="row no-wrap items-start" style="overflow-x: auto">
                <div style="padding-top: 6px" v-show="currentPosId">•</div>
                <div ref="triggerEl">
                  <table
                    class="dialog-table"
                    style="margin-top: -3px"
                    v-if="contextParameterContainerEl"
                  >
                    <parameter-inline
                      :is-root="true"
                      ref="template_edit"
                      :use-vendor-code="true"
                      :use-storage-field="isIncome"
                      :id="'move-dialog'"
                      :editable="true"
                      :storage-for-hint="getStorageFilter"
                      v-model="parameters"
                      :token-styles="tokenStyles"
                      @storagePosChange="onPosChange"
                      :is-table="true"
                      :create-mode="true"
                      :context-trigger="contextParameterContainerEl"
                    ></parameter-inline>
                  </table>
                </div>
              </div>
              <q-btn
                v-if="!isPositionInputEmpty"
                dense
                flat
                color="accent"
                size="14px"
                :icon="clearIconName"
                class="q-pa-none q-mx-sm"
                @click="resetTemplate"
              />
              <div
                :class="
                  'row no-wrap cursor-pointer q-pa-none q-ml-sm q-mr-xl q-mt-xs ' +
                  (additionEnabled ? 'cursor-pointer' : 'disabled')
                "
                @click="addPositionClick"
              >
                <q-icon
                  :name="newIconName"
                  v-if="currentPosId <= 0"
                  class="cursor-pointer q-mr-xs"
                  size="20px"
                  color="grey-6"
                  title=""
                />
                <q-icon
                  :name="addPositionIconName"
                  class="cursor-pointer"
                  size="20px"
                  color="grey-6"
                  title=""
                />
                <q-tooltip
                  v-if="addButtonHint"
                  :delay="300"
                  anchor="top middle"
                  self="center middle"
                >
                  {{ addButtonHint }}
                </q-tooltip>
              </div>
            </div>
          </div>

          <!-- Позиции -->
          <div class="field-group" v-if="theModel.positions?.length">
            <div class="bold-name">{{ $t('action_positions') }}:</div>
            <positions-table-html
              v-model="theModel.positions"
              @recalc="recalcTotals"
              :create-type="createCompoundType"
              :current-storage="theModel.from"
              :hide-remove-btn="isEditMode"
              :can-edit="!isEditMode || isEditing"
              :can-edit-quantity="!isEditMode"
              :read-only="readOnly"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <div v-if="(!isEditMode || isIncome) && !readOnly" class="field-group q-mb-md">
      <div class="row no-wrap justify-end">
        <q-btn
          no-caps
          :label="
            !isEditMode
            ? $t('create_short')
            : (isEditing ? (isLoading ? $t('loading_short') : $t('save')) : $t('edit'))
          "
          color="primary"
          unelevated
          :disable="
            isEditMode && ((isIncome && !canEditIncome) || (isEditing && !creationAllowed)) ||
            !isEditMode && !creationAllowed ||
            (!isEditMode || isEditing) && !allEntitiesLockedByUs ||
            isLoading
          "
          @click.stop="actionButtonClick"
        >
          <q-tooltip v-if="actionButtonDisableReason" :delay="300" anchor="top middle" self="center middle">
            {{ actionButtonDisableReason }}
          </q-tooltip>
        </q-btn>
        <q-btn :label="$t('cancel_short')" no-caps flat @click="handleEsc" />
      </div>
    </div>
  </q-card>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
import ConnectionsTableHtml from "./ConnectionsTableHtml.vue";
import PositionsTableHtml, { PositionLine } from "./PositionsTableHtml.vue";
import InlineDescriptor, { Token } from "./InlineDescriptor.vue";
import ChipsInline from "./ChipsInline.vue";
import { storagePositionsStore } from "@/store/storage/storage-positions";
import { reactive, ref, type ComponentPublicInstance } from "vue";
import { ownsEscape } from "@/composables/overlayStack";
import { storageStore } from "@/store/storage/storage-instances";
import {
  CommonEntity,
  NumericResponse,
  SingleIdResponse,
} from "@/models/interfaces/common";
import {
  BillConnectionWithValues,
  BillConnectionWithValuesEditAsker,
  CommonEntityWithCount,
  ExistingStorageItemForMovementCreation,
  NewStorageItemForMovementCreation,
  PaymentCreateRequest,
  StorageDetailsEditRequest,
  StorageItemExpenditureMovementCreateRequest,
  StorageItemIncomeCreateRequest,
  StorageItemIncomeEditRequest,
  StorageItemMovementToProjectAttachAsker,
  StorageItemNameContainer,
  StorageItemPlain,
  StorageDetailsTemplateDto,
  StorageWithItems,
} from "@/models/interfaces/storage/storage-models";
import {
  BillConnectionToItemIncomeWithValues,
  BillInfo,
  BillLinkedBase,
  BillSearchedWithConnections,
  BillWithManyLinks,
  BillWithOneLink,
  StorageItemMovementInFinances,
  StorageItemMovementInfo,
} from "@/models/interfaces/finances/finance-models";
import {
  ParameterInstance,
  ParameterInstanceContainer,
} from "../../../models/interfaces/parameters/parameter-models";
import {
  mapCreateContainerToInstance,
  mapFilledContainerFromInstance,
  isInstanceContainerEmpty,
  mapStorageItemInstanceToParameterInstance,
} from "../../../models/helpers/parameter-helpers";
import _ from "lodash";
import {
  V2ParameterValueSet_ValueType,
  V2ParameterValueType,
} from "../../../models/etc/parameter-types";
import {
  BillConnectionWithValuesTypeDescriptor,
  BillLinkedTypeDescriptor,
  BillSearchedTypeDescriptor,
  BillType,
  ParameterInstanceContainerType,
  StorageItemPriceType,
  V2FieldValueDisplayType,
  V2RecordAxisType,
  V2StorageItemMovementType,
} from "../../../models/etc/types";
import { storageMovementsStore } from "../../../store/storage/storage-movements";
import { ParameterInstanceCreateContainer } from "../../../models/interfaces/entity-settings/parameters/parameters";
import {
  LockedEntityType,
  MultiEditEntityContainer,
} from "../../../store/interfaces/types.analytics";
import {
  BillRowProps,
  ConnectionLine,
  useEntityStore,
} from "../../../store/heartbeat-workers/useEntityStore";
import NativeInput from "../../common/basic/NativeInput.vue";
// import ItemAdditionComponent from "./ItemAdditionComponent.vue";
import SelectorPopup from '@/components/common/aux-selector/SelectorPopup.vue';
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { auxStore } from "../../../store/auxillary";
import PaymentCreateComponent, {
  PaymentStructure,
} from "./info-dialogs/PaymentCreateComponent.vue";
import { financesStore } from "../../../store/finances";
import { rootStore } from "../../../store";
import { roundTo } from "../../../utils/auxfunc";
import { i18n } from "../../../i18n";
import { intlLocale } from "@/utils/format";

type Money = number;
export interface ReceiptProject {
  id: string;
  name: string;
}
export interface DescriptorModel extends Record<string, Token[]> {}

export interface ReceiptModel {
  open: boolean;
  from: number | null;
  to: number | null;
  projects: CommonEntity[];
  // accounts: ConnectionLine[];
  positions: PositionLine[];
  comment: string;
  VendorCode: string;
  files: { name: string; date: string; size: number }[];
}

interface PendingFile {
  tempId: string; // для ключей в v-for
  file: File; // сам объект файла для FormData
  name: string;
}

@Component({
  name: "MovementCreateComponent",
  emits: ["close"],
  components: {
    ConnectionsTableHtml,
    PositionsTableHtml,
    InlineDescriptor,
    ChipsInline,
    NativeInput,
    // ItemAdditionComponent,
    PaymentCreateComponent,
    SelectorPopup,
    AppIcon,
  },
})
export default class MovementCreateComponent extends Vue {
	get isMobile() {
		return window.innerWidth <= 480;
	}

  @Prop({ default: undefined }) readonly createType!:
    | V2StorageItemMovementType
    | undefined;
  @Prop({ type: Number, default: 0 }) existingMovementId!: number;
  @Prop({ default: undefined }) containerForPreload!: MultiEditEntityContainer;
  @Prop({ default: undefined }) sourceModel!: ReceiptModel;
  @Prop({ type: Boolean, default: false }) readOnly!: boolean;

  contextParameterContainerEl: any = undefined;
  showPosInfoMode: boolean = false;
  projectMenuVisible: boolean = false;
  createLoadedType: V2StorageItemMovementType | undefined = undefined;

  newPayment: PaymentStructure = reactive({
    paymentType: BillType.Incoming,
    paymentAmount: 0,
    paymentNumber: "",
    paymentDate: new Date(),
    currencyName: i18n.global.t('rub')+".",
    paymentCurrency: 1,
    paymentNote: "",
  } as PaymentStructure);

  // tabs switch model
  accounts_tab = "account_selector";
  dataLoading: boolean = false;
  // Загрузка в mounted асинхронная, а окно можно закрыть раньше, чем она закончится.
  // После каждого await проверяем, живо ли ещё окно
  isUnmounted = false;

  lastCommentCaretPosition = 0;
  private _blockCaretUpdate = false;
  existingMovementComment = "";
  // Текст на момент загрузки движения: с ним сравниваем при сохранении и к нему откатываемся по Esc.
  movementCommentAtOpen = "";
  existingMovementCreatorId: number | null = null;

  // custom icons
  private attachIconUrl: string = require("@/assets/attach.svg");
  // вычисляемое свойство, которое Quasar ожидает в виде строки "img:URL"
  get fileIconName(): string {
    return `img:${this.attachIconUrl}`;
  }

  // icons for position addition
  private clearIconUrl: string = require("@/assets/arrow_back.svg");
  // вычисляемое свойство, которое Quasar ожидает в виде строки "img:URL"
  get clearIconName(): string {
    return `img:${this.clearIconUrl}`;
  }

  private newIconUrl: string = require("@/assets/icon-add.svg");
  // вычисляемое свойство, которое Quasar ожидает в виде строки "img:URL"
  get newIconName(): string {
    return `img:${this.newIconUrl}`;
  }

  private addPositionIconUrl: string = require("@/assets/add_position.svg");
  // вычисляемое свойство, которое Quasar ожидает в виде строки "img:URL"
  get addPositionIconName(): string {
    return `img:${this.addPositionIconUrl}`;
  }

  currentPosId = 0;
  currentPosPrice = 0;
  currentPosPriceType = 0;
  currentPosUnit = 0;
  isStorageConfirmed = false;
  currentPosStorages: CommonEntityWithCount[] = [];

  // if true then editing is enabled; can be true only if isEditMode is true
  isEditing: boolean = false;
  comment_templates = reactive([]);
  tids: number[] = [];

  modelValue: ReceiptModel = reactive({
    open: true,
    from: null,
    to: null,
    projects: [],
    // accounts: [],
    positions: [],
    files: [],
    comment: "",
    VendorCode: "",
  });

  tmp_accounts: {
    Id: number;
    isPreloaded: boolean;
    billRowType: BillRowProps;
    Name: string;
    bill: BillSearchedWithConnections | BillLinkedBase;
  }[] = reactive([]);

  // Промежуточная модель для single-select селектора счетов: сюда попадает
  // последний выбранный счёт, откуда он добавляется в tmp_accounts.
  tmp_selected_account: {
    Id: number;
    isPreloaded: boolean;
    billRowType: BillRowProps;
    Name: string;
    bill: BillSearchedWithConnections | BillLinkedBase;
  }[] = reactive([]);

  tmp_payments: ConnectionLine[] = reactive([]);
  deleted_accounts: ConnectionLine[] = reactive([]);

  parameters = reactive<ParameterInstanceContainer[]>([]);
  tokenStyles: Record<string, string> = {
    artikul: "tok--link",
    name: "tok--base",
    class: "tok--muted",
  };

  searchText = "";

  // stores import
  storage: any | undefined = undefined;
  storage_pos: any | undefined = undefined;
  storage_move: any | undefined = undefined;
  auxstore: any | undefined = undefined;
  entity_store: any | undefined = undefined;
  finStore: any | undefined = undefined;
  rootstore: any | undefined = undefined;

  // clean template
  containerTemplate: ParameterInstanceCreateContainer | undefined;
  showVendorCode: boolean = true;

  isLoading: boolean = false;

  attachedFiles: CommonEntity[] = reactive([]);
  pendingFiles = reactive<PendingFile[]>([]);

  // Возврат с проекта
  createMovementMode = false;
  createMoveType: V2StorageItemMovementType = V2StorageItemMovementType.Inner;
  returnReceiptModel: ReceiptModel = reactive({
    open: true,
    from: null,
    to: null,
    projects: [],
    // accounts: [],
    positions: [],
    files: [],
    comment: "",
    VendorCode: "",
  });

  created() {
    this.storage = storageStore();
    this.storage_pos = storagePositionsStore();
    this.storage_move = storageMovementsStore();
    this.auxstore = auxStore();
    this.entity_store = useEntityStore();
    this.finStore = financesStore();
    this.rootstore = rootStore();

    this.attachedFiles = reactive([]);
    this.pendingFiles = reactive([]);
    this.tids = [];
    this.entity_store.accounts = reactive([]);

    this.isStorageConfirmed = this.isIncome;

    this.applyDefaultStorages();
    if (this.storage.storages_with_items === undefined) {
      void this.storage.ensureStoragesWithItems().then(() => this.applyDefaultStorages());
    }
    void this.storage_pos.ensureNameContainerAndUnits();
  }

  // Склады по умолчанию ставятся только в пустые поля, потому что к концу загрузки списка там
  // уже может стоять склад из открытого движения или из выбранных позиций
  applyDefaultStorages() {
    if (this.isIncome && this.theModel.to == null && this.storageOptions.length) {
      const lastToStr = localStorage.getItem("last_selected_move_to");
      if (lastToStr) {
        this.theModel.to = parseInt(lastToStr);
      } else {
        this.theModel.to = this.storageOptions[0]?.value;
      }
    }

    if (this.isExpense || this.isTransfer) {
      if (this.isTransfer && this.theModel.to == null) {
        const lastToStr = localStorage.getItem("last_selected_move_to");
        if (lastToStr) {
          this.theModel.to = parseInt(lastToStr);
        } else if (this.storageOptions.length) {
          this.theModel.to = this.storageOptions[0]?.value;
        }
      }

      if (this.theModel.from == null) {
        const lastFromStr = localStorage.getItem("last_selected_move_from");
        if (lastFromStr) {
          this.theModel.from = parseInt(lastFromStr);
        } else if (this.storageOptions.length) {
          this.theModel.from = this.storageOptions[0]?.value;
        }
      }
      // after pre-loading selected put storage here from the first one
    }
  }

  async mounted() {
    window.addEventListener("keydown", this.onEscKeydown);
    this.contextParameterContainerEl = this.$refs.triggerEl;

    // для возврата с проекта
    if (this.sourceModel) {
      this.modelValue = reactive(this.sourceModel);
      for (const pos of this.theModel.positions) {
        if (pos.id) {
          const locked = await this.blockPosition(pos.id);
          if (this.isUnmounted) return;
          if (!locked) {
            pos.blocked_by_other = true;
          }
        }
      }
    } else {
      // get preselected
      await this.preloadEntities();
      if (this.isUnmounted) return;
      await this.preloadExistingMovement();
      if (this.isUnmounted) return;
    }
    this.resetTemplate();

    // @ts-ignore
    if (this.$refs.cardRootRef && this.$refs.cardRootRef.$el) {
      // @ts-ignore
      this.$refs.cardRootRef.$el.focus();
    }
  }

  get createCompoundType(): V2StorageItemMovementType | undefined {
    return this.createType !== undefined
      ? this.createType
      : this.createLoadedType;
  }

  // reactive model
  get theModel(): ReceiptModel {
    return this.modelValue;
  }

  set theModel(val: ReceiptModel) {
    this.modelValue = val;
  }

  // basic computed getters
  get isEditMode() {
    return this.existingMovementId > 0;
  }

  // width function
  get priceOptions() {
    return [
      {
        Name: this.$t('price_last_receipt'),
        Id: StorageItemPriceType.LastIncome,
      },
      {
        Name: this.$t('set_by_user'),
        Id: StorageItemPriceType.SetByUser,
      },
    ];
  }

  get creationAllowed(): boolean {
    if (this.isTransfer && (this.theModel.from == this.theModel.to)) { return false }

    let nullPositions = false;
    for (let ps = 0; ps < this.theModel.positions.length; ps++) {
      if (this.theModel.positions[ps].qty <= 0) {
        nullPositions = true;
      }
    }
    return (
      this.theModel.positions.length > 0 &&
      (this.sumsEqualForCreation ||
        !this.isIncome ||
        (this.canCreateWithoutBills && this.accountsTotal === 0)) &&
      (this.canCreateWithoutBills || this.positionsTotal > 0) &&
      !nullPositions
    );
  }

  /** Все счета (не платежи) и позиции с id заблокированы нами; иначе кнопка Сохранить/Создать disabled */
  get allEntitiesLockedByUs(): boolean {
    const store = this.entity_store;
    const accounts = (store.accounts || []) as ConnectionLine[];
    const accsOnly = accounts.filter(
      (acc) =>
        acc.bill &&
        (acc.billRowType !== BillRowProps.BillSearchedBase || (acc.bill as { Descriptor?: number }).Descriptor !== BillSearchedTypeDescriptor.Payment) &&
        (acc.billRowType !== BillRowProps.BillLinkedBase || (acc.bill as { Descriptor?: number }).Descriptor !== BillLinkedTypeDescriptor.Payment)
    );
    for (const acc of accsOnly) {
      const billId = (acc.bill as { Id?: number })?.Id;
      if (billId != null && store.getLockStatus(billId, LockedEntityType.Bill) !== "locked") return false;
    }
    const positions = this.theModel?.positions ?? [];
    for (const pos of positions) {
      if (pos.id && store.getLockStatus(pos.id, LockedEntityType.StorageItem) !== "locked") return false;
    }
    return true;
  }

  get nameContainerMutated() {
    return _.cloneDeep(this.storage_pos?.currentItemNameContainer);
  }

  // for template
  get isIncome() {
    return this.createCompoundType === V2StorageItemMovementType.In;
  }

  get isExpense() {
    return this.createCompoundType === V2StorageItemMovementType.Out;
  }

  get isTransfer() {
    return this.createCompoundType === V2StorageItemMovementType.Inner;
  }

  get sumsEqualForCreation() {
    return this.accountsTotal === this.positionsTotal;
  }

  get getStorageFilter(): number {
    return this.createCompoundType !== V2StorageItemMovementType.In
      ? this.theModel.from || 0
      : 0;
  }

  get storageOptions() {
    if (!this.storage) {
      return [];
    }

    const allOptions = (this.storage.storagesWithItems as CommonEntity[]).map(
      (el) => {
        return { label: el.Name, value: el.Id };
      },
    );

    if (this.searchText) {
      // Фильтруем список на основе ввода в поле поиска
      const needle = this.searchText.toLowerCase();
      return allOptions.filter(
        (v) => v.label.toLowerCase().indexOf(needle) > -1,
      );
    } else {
      return allOptions;
    }
  }

  get parameterContainer() {
    if (!this.storage) {
      return [];
    }
    return (this.storage.storagesWithItems as CommonEntity[]).map((el) => {
      return { label: el.Name, value: el.Id };
    });
  }

  get accountsTotal(): Money {
    const acc_sum = +(
      (this.entity_store.accounts as ConnectionLine[]) ?? []
    ).reduce((s, a) => s + (+a.amount || 0), 0);
    const pay_sum = +((this.tmp_payments as ConnectionLine[]) ?? []).reduce(
      (s, a) => s + (a.bill ? +a.bill.TotalAmount : 0),
      0,
    );

    console.log(acc_sum + " " + pay_sum);
    console.log(acc_sum + pay_sum);
    return acc_sum + pay_sum;
  }

  get positionsTotal(): Money {
    console.log('total reaclc');
    return (this.theModel.positions ?? []).reduce(
      (s, p) => s + (p.amount || 0),
      0,
    );
  }

  returnFromProject(createMode: V2StorageItemMovementType) {
    this.returnReceiptModel = reactive({
      open: true,
      from: this.modelValue.to,
      to:
        createMode == V2StorageItemMovementType.Inner
          ? this.modelValue.from
          : null,
      projects:
        createMode == V2StorageItemMovementType.Out
          ? _.cloneDeep(this.modelValue.projects)
          : [],
      // accounts: [],
      positions: _.cloneDeep(
        this.modelValue.positions
          .map((pos) => {
            return {
              ...pos,
              storagesWithQuantities:
                (this.storage.storagesWithItems as StorageWithItems[]).map(
                  (el) => {
                    return {
                      Id: el.Id,
                      Name: el.Name,
                      Count:
                        el.Items.find((it) => it.Id === pos.id)?.Count || 0,
                    } as CommonEntityWithCount;
                  },
                ) || [],
            };
            // фильтрация позиций, которых нет на складе "откуда"
          })
          .filter(
            (el) =>
              (el.storagesWithQuantities.find(
                (sq) => sq.Id === this.theModel.to,
              )?.Count || 0) > 0,
          ),
      ),
      files: [],
      comment: "",
      VendorCode: "",
    });

    this.createMoveType = createMode;
    this.createMovementMode = true;
  }

  onCaretPositionChange(val: number) {
    if (val >= 0 && !this._blockCaretUpdate) {
      this.lastCommentCaretPosition = +val;
    }
  }

  onCommentBlur() {
    this._blockCaretUpdate = true;
    setTimeout(() => {
      this._blockCaretUpdate = false;
    }, 0);
  }

  onNativeInputClick() {
    if (!this.canEditMovementComment || (this.isEditMode && !this.isEditing)) return;
    setTimeout(() => {
      const ref = this.$refs.comment_field as any;
      const field = ref?.$refs?.editable_field as HTMLElement | null;
      if (!field) return;
      const sel = window.getSelection();
      if (sel && sel.rangeCount > 0) {
        const range = sel.getRangeAt(0);
        const pre = range.cloneRange();
        pre.selectNodeContents(field);
        pre.setEnd(range.endContainer, range.endOffset);
        this.lastCommentCaretPosition = pre.toString().length;
      }
    }, 0);
  }

  get currentCommentValue(): string {
    return this.isEditMode ? this.existingMovementComment : this.theModel.comment;
  }

  setCommentValue(val: string) {
    if (this.isEditMode) {
      this.existingMovementComment = val || "";
      return;
    }
    this.theModel.comment = val || "";
  }

  @Watch("comment_templates")
  comment_template_watcher() {
    if (!this.comment_templates.length) {
      return;
    }

    const templateText = (this.comment_templates[0] as StorageDetailsTemplateDto).Text;
    const original = this.currentCommentValue || "";
    this.tids.push((this.comment_templates[0] as StorageDetailsTemplateDto).Id);

    let c_pos = this.lastCommentCaretPosition;
    if (c_pos < 0) {
      c_pos = 0;
    } else if (c_pos > original.length) {
      c_pos = original.length;
    }

    this._blockCaretUpdate = true;
    this.setCommentValue(original.slice(0, c_pos) + templateText + original.slice(c_pos));
    this.lastCommentCaretPosition = c_pos + templateText.length;
    this.comment_templates.splice(0);

    // @ts-ignore
    this.$refs.comment_template_menu && this.$refs.comment_template_menu.hide();
    this.$nextTick(() => {
      this._blockCaretUpdate = false;
    });
  }

  async addCommentTemplate(t_name: string) {
    const noteForTemplate = this.currentCommentValue;
    if (
      t_name &&
      t_name.length &&
      noteForTemplate &&
      noteForTemplate.length
    ) {
      this.storage_move.createMovementNoteTemplate({
        Name: t_name,
        Text: noteForTemplate,
      });
    }
  }

  async deleteCommentTemplate(t_id: number) {}

  // preload existing movement
  async preloadExistingMovement() {
    if (this.isEditMode) {
      this.dataLoading = true;

      const existing_move: StorageItemMovementInfo =
        await this.storage_move.getStorageMovementInfo(this.existingMovementId);
      if (this.isUnmounted) return;
      // Стор возвращает undefined, если запрос не прошёл или его отменил запрос из другого окна
      if (!existing_move) {
        this.dataLoading = false;
        return;
      }
      this.createLoadedType = existing_move.MovementType;

      if (existing_move && existing_move.Items.length) {
        const new_positions: PositionLine[] = existing_move.Items.map((pr) => {
          const pos_copy = mapStorageItemInstanceToParameterInstance(
            pr.NameParameters,
          );

          const vcode_cell = {
            Type: ParameterInstanceContainerType.SingleInstance,
            Instance: {
              TemplateId: 999,
              Unremovable: true,
              ValueType: V2ParameterValueType.String,
              StringValue: pr.VendorCode,
              NumberValue: null,
              DateValue: null,
              BoolValue: null,
              ValueSet: null,
              SelectedValue: null,
              ValueDisplayType: V2FieldValueDisplayType.Inline,
              Name: this.$t('sku'),
              Id: 0,
              Round: 2,
              RecordAxisType: V2RecordAxisType.Horizontal,
              RecordFields: [],
            } as ParameterInstance,
            ListTitle: null,
          } as ParameterInstanceContainer;

          /*  const storage_cell = {
            Type: ParameterInstanceContainerType.SingleInstance,
            Instance: {
              TemplateId: 998,
              Unremovable: true,
              ValueType: V2ParameterValueType.ValueSet,
              StringValue: null,
              NumberValue: null,
              DateValue: null,
              BoolValue: null,
              ValueSet: {
                Id: 998,
                Name: this.$t('warehouse'),
                StringName: '',
                ValueType: V2ParameterValueSet_ValueType.String
              },
              SelectedValue: null,
              ValueDisplayType: V2FieldValueDisplayType.Inline,
              Name: this.$t('warehouse'),
              Id: 0,
              Round: 2,
              RecordAxisType: V2RecordAxisType.Horizontal,
              RecordFields: [],
            } as ParameterInstance,
            ListTitle: null,
          } as ParameterInstanceContainer; */

          return {
            id: pr.Id,
            qty: pr.ItemQuantity,
            amount: pr.TotalAmount,
            price: pr.SingleItemPrice,
            priceByLastIncome:
              pr.PriceType === StorageItemPriceType.LastIncome
                ? pr.SingleItemPrice
                : 0,
            MeasureUnit: pr.MeasureUnit,
            PriceType: this.priceOptions.find(
              (el) => el.Id === pr.PriceType,
            ) || {
              Name: this.$t('set_by_user'),
              Id: StorageItemPriceType.SetByUser,
            },
            pos: pos_copy,
            // this.createCompoundType === V2StorageItemMovementType.In ?
            pos_with_vcode:
              //  [vcode_cell, ...pos_copy, storage_cell] :
              [vcode_cell, ...pos_copy],
            storagesWithQuantities: [],
            new_p: false,
          } as PositionLine;
        });

        this.modelValue = reactive({
          ...this.theModel,
          positions: new_positions,
        });
      }

      this.tmp_accounts = existing_move.Bills.filter(
        (b) => b.Descriptor !== BillLinkedTypeDescriptor.Payment,
      ).map((bill) => {
        const payed =
          bill.Descriptor === BillLinkedTypeDescriptor.BillWithOneLink
            ? (bill as BillWithOneLink).PayedAmount
            : bill.Descriptor === BillLinkedTypeDescriptor.BillWithManyLinks
            ? (bill as BillWithManyLinks).PayedAmount
            : 0;

        return {
          Id: bill.Id,
          isPreloaded: true,
          Name:
            String(this.$t(bill.Type === 0 ? 'inc_abbr' : 'out_abbr')) +
            " " +
            bill.Number +
            " " +
            bill.TotalAmount +
            " " +
            payed +
            " " +
            bill.Note,
          bill: { ...bill, Connections: [] },
          billRowType: BillRowProps.BillLinkedBase,
        };
      });

      this.tmp_payments = existing_move.Bills.filter(
        (b) => b.Descriptor === BillLinkedTypeDescriptor.Payment,
      ).map((bill) => {
        // this.blockAccount(bill.Id);
        return {
          // conn_id: 0,
          percent: 0,
          amount: 0,
          debit: 0,
          maxAmount: 0,
          limitAmount: 0,
          maxDebit: 0,
          maxPercent: 0,
          bill: bill,
          billRowType: BillRowProps.BillLinkedBase,
          canEditAmounts: false,
          canEditDebits: false,
          canBeDeleted: false,
          nonExistent: false,
          movement: undefined,
        } as ConnectionLine;
      });

      this.modelValue = reactive({
        ...this.theModel,
        projects: existing_move.Projects,
      });

      if (
        existing_move.MovementType === V2StorageItemMovementType.In ||
        existing_move.MovementType === V2StorageItemMovementType.Inner
      ) {
        this.theModel.to = existing_move.ReceiverStorage?.Id;
      }
      if (
        existing_move.MovementType === V2StorageItemMovementType.Out ||
        existing_move.MovementType === V2StorageItemMovementType.Inner
      ) {
        this.theModel.from = existing_move.SourceStorage?.Id;
      }
      this.existingMovementComment = existing_move.Details || "";
      this.existingMovementCreatorId = existing_move.Creator?.Id ?? null;
      this.movementCommentAtOpen = this.existingMovementComment;
      this.theModel.comment = this.existingMovementComment;
      this.theModel.VendorCode = existing_move.VendorCode;
      this.attachedFiles = existing_move.Files;

      this.dataLoading = false;
    }

    this.isStorageConfirmed = this.isIncome || this.isEditMode;
  }

  // from table multi edit container; in create mode only;
  async preloadEntities() {
    if (!this.isEditMode && this.containerForPreload) {
      this.dataLoading = true;
      const preloaded: StorageItemPlain[] =
        await this.storage_pos.getItemsForNewMovement(this.containerForPreload);
      if (this.isUnmounted) return;

      // set storage 'from' from the 1st position that has Count > 0 on some storage
      const firstPos = preloaded.find(
        (pos) => pos.QuantitiesInStock.findIndex((q) => q.Count > 0) > -1,
      );
      if ((this.isTransfer || this.isExpense) && firstPos) {
        this.theModel.from = firstPos.QuantitiesInStock.find(
          (q) => q.Count > 0,
        )?.Id;
      }

      if (preloaded.length) {
        const new_positions: PositionLine[] = preloaded.map((pr) => {
          const pos_copy = mapStorageItemInstanceToParameterInstance(
            pr.NameParameters,
          );

          const vcode_cell = {
            Type: ParameterInstanceContainerType.SingleInstance,
            Instance: {
              TemplateId: 999,
              Unremovable: true,
              ValueType: V2ParameterValueType.String,
              StringValue: pr.VendorCode,
              NumberValue: null,
              DateValue: null,
              BoolValue: null,
              ValueSet: null,
              SelectedValue: null,
              ValueDisplayType: V2FieldValueDisplayType.Inline,
              Name: this.$t('sku'),
              Id: 0,
              Round: 2,
              RecordAxisType: V2RecordAxisType.Horizontal,
              RecordFields: [],
            } as ParameterInstance,
            ListTitle: null,
          } as ParameterInstanceContainer;

          /* const storage_cell = {
            Type: ParameterInstanceContainerType.SingleInstance,
            Instance: {
              TemplateId: 998,
              Unremovable: true,
              ValueType: V2ParameterValueType.ValueSet,
              StringValue: null,
              NumberValue: null,
              DateValue: null,
              BoolValue: null,
              ValueSet: {
                Id: 998,
                Name: this.$t('warehouse'),
                StringName: '',
                ValueType: V2ParameterValueSet_ValueType.String
              },
              SelectedValue: null,
              ValueDisplayType: V2FieldValueDisplayType.Inline,
              Name: this.$t('warehouse'),
              Id: 0,
              Round: 2,
              RecordAxisType: V2RecordAxisType.Horizontal,
              RecordFields: [],
            } as ParameterInstance,
            ListTitle: null,
          } as ParameterInstanceContainer; */

          return {
            id: pr.Id,
            qty: 0,
            amount: 0,
            price: pr.Price,
            priceByLastIncome:
              pr.PriceType === StorageItemPriceType.LastIncome ? pr.Price : 0,
            MeasureUnit: pr.MeasureUnit,
            PriceType:
              pr.PriceType == 0
                ? {
                    Name: this.$t('price_last_receipt'),
                    Id: StorageItemPriceType.LastIncome,
                  }
                : {
                    Name: this.$t('set_by_user'),
                    Id: StorageItemPriceType.SetByUser,
                  },
            pos: pos_copy,
            // this.createCompoundType === V2StorageItemMovementType.In ?
            pos_with_vcode:
              // [vcode_cell, ...pos_copy, storage_cell] :
              [vcode_cell, ...pos_copy],
            storagesWithQuantities: pr.QuantitiesInStock,
          } as PositionLine;
        });

        // console.log('existing preloaded positions:')
        // console.log(new_positions)

        this.modelValue = reactive({
          ...this.theModel,
          positions: new_positions,
        });

        for (let accb = 0; accb < new_positions.length; accb++) {
          const locked = await this.blockPosition(new_positions[accb].id);
          if (this.isUnmounted) return;
          if (!locked) {
            this.theModel.positions[accb].blocked_by_other = true;
          }
        }
      }
      this.dataLoading = false;
    }
  }

  confirmStorage() {
    // оставить только позиции, которые есть на складе
    const updatedPositions = this.theModel.positions.filter((position) => {
      const shouldKeep =
        position.storagesWithQuantities.findIndex(
          (q) => q.Id === this.theModel.from && q.Count > 0,
        ) >= 0;
      if (!shouldKeep) {
        this.unblockPosition(position.id);
      }
      return shouldKeep;
    });

    this.theModel.positions = updatedPositions;
    this.theModel.positions.forEach((pos) => (pos.qty = 1));
    this.isStorageConfirmed = true;
  }

  addNewPayment() {
    // @ts-ignore
    this.$refs.acc_menu && this.$refs.acc_menu.hide();

    this.tmp_payments = [
      ...this.tmp_payments,
      {
        // conn_id: 0,
        percent: 0,
        amount: 0,
        debit: 0,
        maxAmount: 0,
        limitAmount: 0,
        maxDebit: 0,
        maxPercent: 0,

        bill: {
          TotalAmount: this.newPayment.paymentAmount, // = TotalAmount
          Descriptor: BillLinkedTypeDescriptor.Payment,
          Id: 0,
          Number: this.newPayment.paymentNumber, // номер счета
          Date: this.newPayment.paymentDate, // дата создания
          Counterparty: {
            Id: 0,
            Name: "",
          }, // кому дан
          Type: this.newPayment.paymentType, //тип вх исх
          Note: this.newPayment.paymentNote, // заметка
          Currency: this.newPayment.currencyName, // валюта
          CurrencyRate:
            this.newPayment.paymentCurrency > 0
              ? this.newPayment.paymentCurrency
              : 1,
          IsDraft: true,
          Rate:
            this.newPayment.paymentCurrency > 0
              ? this.newPayment.paymentCurrency
              : 1, // internal
          // IsBill?: boolean; (!= BillLinkedTypeDescriptor.Payment)
          Instance1C: "",
        } as BillLinkedBase,
        billRowType: BillRowProps.BillLinkedBase,
        canEditAmounts: false,
        canEditDebits: false,
        canBeDeleted: false,
        nonExistent: false,
        movement: undefined,
      } as ConnectionLine,
    ];

    // reset new one
    this.newPayment = reactive({
      paymentType: BillType.Incoming,
      paymentAmount: 0,
      paymentNumber: "",
      paymentDate: new Date(),
      currencyName: this.$t('rub')+".",
      paymentCurrency: 1,
      paymentNote: "",
    } as PaymentStructure);
  }

  onPosChange(val: any) {
    this.currentPosId = val?.currentPosId || 0;
    this.currentPosPrice = val?.currentPosPrice || 0;
    this.currentPosPriceType = val?.currentPosPriceType || 0;
    this.currentPosUnit = val?.currentPosUnit || 0;
    this.currentPosStorages = val?.currentPosStorages || [];
  }

  @Watch("nameContainerMutated", { deep: true })
  item_container_watcher(val: StorageItemNameContainer | undefined) {
    const that = this;
    if (val && val.ParameterContainer) {
      that.containerTemplate = val.ParameterContainer;
      that.showVendorCode = val.ShowVendorCode;
    } else {
      const cur_cont = _.cloneDeep(this.storage_pos?.currentItemNameContainer);
      if (cur_cont && cur_cont.ParameterContainer) {
        that.containerTemplate = cur_cont.ParameterContainer;
      } else {
        that.containerTemplate = undefined;
      }
      that.showVendorCode = true;
    }
    this.resetTemplate();
  }

  resetTemplate() {
    this.parameters.splice(0);
    if (this.$refs.template_edit) {
      // @ts-ignore
      this.$refs.template_edit.clearCurrentPositionMark();
    }

    if (this.containerTemplate) {
      this.parameters = mapCreateContainerToInstance(this.containerTemplate); //[0].Instance.RecordFields;
    } else {
      this.parameters = reactive([]);
    }

    if (this.showVendorCode) {
      const vcode_cell = {
        Type: ParameterInstanceContainerType.SingleInstance,
        Instance: {
          TemplateId: 999,
          Unremovable: true,
          ValueType: V2ParameterValueType.String,
          StringValue: "",
          NumberValue: null,
          DateValue: null,
          BoolValue: null,
          ValueSet: null,
          SelectedValue: null,
          ValueDisplayType: V2FieldValueDisplayType.Inline,
          Name: this.$t('sku'),
          Id: 0,
          Round: 2,
          RecordAxisType: V2RecordAxisType.Horizontal,
          RecordFields: [],
        } as ParameterInstance,
        ListTitle: null,
      } as ParameterInstanceContainer;
      this.parameters.splice(0, 0, vcode_cell);
    }

    if (this.createCompoundType === V2StorageItemMovementType.In) {
      const storage_cell = {
        Type: ParameterInstanceContainerType.SingleInstance,
        Instance: {
          TemplateId: 998,
          Unremovable: true,
          ValueType: V2ParameterValueType.ValueSet,
          StringValue: "",
          NumberValue: null,
          DateValue: null,
          BoolValue: null,
          ValueSet: {
            Id: 998,
            Name: this.$t('warehouse'),
            StringName: "",
            ValueType: V2ParameterValueSet_ValueType.String,
          },
          SelectedValue: null,
          ValueDisplayType: V2FieldValueDisplayType.Inline,
          Name: this.$t('warehouse'),
          Id: 0,
          Round: 2,
          RecordAxisType: V2RecordAxisType.Horizontal,
          RecordFields: [],
        } as ParameterInstance,
        ListTitle: null,
      } as ParameterInstanceContainer;
      this.parameters.push(storage_cell);
    }

    if (this.$refs.template_edit) {
      // @ts-ignore
      this.$refs.template_edit.rebuildSchema();
    }
  }

  close() {
    this.unblockAll();
    this.entity_store.accounts = reactive([]);
    this.$emit("close", null);
  }

  beforeUnmount() {
    this.isUnmounted = true;
    window.removeEventListener("keydown", this.onEscKeydown);
    this.entity_store.accounts = reactive([]);
  }

  async onProjectsUpdate(newValue: CommonEntity[]) {
    if (!this.existingMovementId) {
      this.modelValue = { ...this.theModel, projects: newValue };
      return;
    }
    const currentIds = new Set((this.theModel.projects || []).map((p: CommonEntity) => p.Id));
    const added = (newValue || []).filter((p: CommonEntity) => p.Id && !currentIds.has(p.Id));
    for (const p of added) {
      const arg: StorageItemMovementToProjectAttachAsker = {
        StorageItemMovementId: this.existingMovementId,
        ProjectId: p.Id,
      };
      if (this.isIncome) {
        await this.storage_move.attachMovementToProject(arg);
      } else {
        await this.storage_move.attachValuedMovementToProject(arg);
      }
    }
    this.modelValue = { ...this.theModel, projects: newValue };
  }

  async removeProject(idx: number) {
    if (!this.existingMovementId) {
      const projects = this.theModel.projects.slice();
      projects.splice(idx, 1);
      this.modelValue = { ...this.theModel, projects };
      return;
    }
    const project = this.theModel.projects[idx];
    if (!project?.Id) return;
    let ok = false;
    if (this.isIncome) {
      const res = await this.storage_move.detachMovementFromProject({
        StorageItemMovementId: this.existingMovementId,
        ProjectId: project.Id,
      } as StorageItemMovementToProjectAttachAsker);
      ok = res?.response_ok === true;
    } else {
      const res = await this.storage_move.detachValuedMovementFromProject({
        Id: this.existingMovementId,
      });
      ok = res?.response_ok === true;
    }
    if (ok) {
      const projects = this.theModel.projects.slice();
      projects.splice(idx, 1);
      this.modelValue = { ...this.theModel, projects };
    }
  }

  removeFile(idx: number) {
    const files = this.theModel.files.slice();
    files.splice(idx, 1);
    this.modelValue = { ...this.theModel, files };
  }

  removeConnection(row: ConnectionLine) {
    if (!row) return;
    const accounts_arr = this.entity_store.accounts as ConnectionLine[];
    const idx = accounts_arr.indexOf(row);
    if (idx < 0) return;
    console.log("remove bill at " + idx);

    const acc = accounts_arr[idx];
    if (!acc.bill) {
      return;
    }
    this.unblockAccount(acc.bill.Id);

    const accounts = accounts_arr.slice();
    const removed_one = accounts.splice(idx, 1);
    // this.modelValue = { ...this.theModel, accounts };
    this.entity_store.accounts = reactive(accounts);
    this.tmp_accounts.splice(idx, 1);

    if (
      removed_one &&
      removed_one.length &&
      this.isEditing &&
      !removed_one[0].nonExistent &&
      removed_one[0].bill &&
      this.deleted_accounts.findIndex(
        (acc) => acc.bill?.Id === removed_one[0].bill?.Id,
      ) < 0
    ) {
      // add to temporary to_delete list
      this.deleted_accounts.push(removed_one[0]);
    }

    console.log(removed_one);
    console.log(this.deleted_accounts);
  }

  removePayment(row: ConnectionLine) {
    if (!row) return;
    const payments_arr = this.tmp_payments as ConnectionLine[];
    const idx = payments_arr.indexOf(row);
    if (idx < 0) return;
    console.log("remove payment at " + idx);
    const acc = payments_arr[idx];
    if (!acc.bill) {
      return;
    }

    this.tmp_payments.splice(idx, 1);
  }

  // Селектор счетов single-select (закрывается после каждого выбора), поэтому кладём
  // выбранный счёт в staging tmp_selected_account и отсюда ДОБАВЛЯЕМ его в накопительный
  // список tmp_accounts, а не заменяем весь список. Иначе каждый новый счёт затирал бы
  // предыдущий (при создании прихода несколько счетов должны накапливаться).
  @Watch("tmp_selected_account")
  onAccountPicked() {
    if (!this.tmp_selected_account.length) return;
    const picked = this.tmp_selected_account[this.tmp_selected_account.length - 1];
    if (!picked?.bill) return;

    // не дублируем уже добавленный счёт/платёж
    const exists = this.tmp_accounts.some((a) => a.bill?.Id === picked.bill.Id);
    if (!exists) {
      // Новый массив-референс, иначе @Watch("tmp_accounts") не сработает
      // (accountsChanged реагирует на смену ссылки, а не на мутацию in-place).
      this.tmp_accounts = reactive([...this.tmp_accounts, picked]);
    }

    // очищаем staging, чтобы повторный выбор того же счёта снова триггерил watcher
    this.tmp_selected_account = reactive([]);
  }

  // TODO: refactor and combine with the same method in the ProjectFinaiceModule.vue
  @Watch("tmp_accounts")
  accountsChanged() {
    this.tmp_payments.push(
      ...this.tmp_accounts
        .filter(
          (b) =>
            ((b.billRowType === BillRowProps.BillSearchedBase &&
              b.bill.Descriptor === BillSearchedTypeDescriptor.Payment) ||
              (b.billRowType === BillRowProps.BillLinkedBase &&
                b.bill.Descriptor === BillLinkedTypeDescriptor.Payment)) &&
            this.tmp_payments.findIndex((p) => p.bill?.Id === b.bill.Id) < 0,
        )
        .map((bill) => {
          // this.blockAccount(bill.Id);
          return {
            // conn_id: 0,
            percent: 0,
            amount: 0,
            debit: 0,
            maxAmount: 0,
            limitAmount: 0,
            maxDebit: 0,
            maxPercent: 0,
            bill: bill.bill,
            billRowType: BillRowProps.BillLinkedBase,
            canEditAmounts: false,
            canEditDebits: false,
            canBeDeleted: false,
            nonExistent: false,
            movement: undefined,
          } as ConnectionLine;
        }),
    );

    // remove payments from tmp accounts
    const accs_only = this.tmp_accounts.filter(
      (acc) =>
        (acc.billRowType === BillRowProps.BillSearchedBase &&
          acc.bill.Descriptor !== BillSearchedTypeDescriptor.Payment) ||
        (acc.billRowType === BillRowProps.BillLinkedBase &&
          acc.bill.Descriptor !== BillLinkedTypeDescriptor.Payment),
    );

    // block accounts only, not payments
    if (!this.readOnly) {
      for (let accb = 0; accb < accs_only.length; accb++) {
        this.blockAccount(accs_only[accb].bill.Id);
      }
    }

    this.entity_store.accounts = reactive(
      accs_only.map((acc) => {
          const conn_already_in_store = this.entity_store.accounts.find(
            (stacc: ConnectionLine) => stacc.bill?.Id === acc.bill.Id,
          ) as ConnectionLine;
          if (conn_already_in_store) return conn_already_in_store;

          let connections_sum = 0;
          let max_percent = 100;
          let max_debit = 0;
          let max_amount = 0;
          let total_amount = 0;

          if (acc.billRowType === BillRowProps.BillSearchedBase) {
            const t_bill = acc.bill as BillSearchedWithConnections;

            for (let ind = 0; ind < t_bill.Connections.length; ind++) {
              connections_sum += t_bill.Connections[ind].AbsoluteAmount;
              max_percent -= t_bill.Connections[ind].AmountPercent;
            }

            total_amount = acc.bill.TotalAmount;
            max_amount = acc.bill.TotalAmount - connections_sum;
            max_debit =
              t_bill.PayedAmount > connections_sum
                ? t_bill.PayedAmount - connections_sum
                : 0;
          } else if (acc.billRowType === BillRowProps.BillLinkedBase) {
            if (
              acc.bill.Descriptor === BillLinkedTypeDescriptor.BillWithOneLink
            ) {
              const t_bill = acc.bill as BillWithOneLink;
              total_amount = t_bill.TotalAmount;
              max_amount = t_bill.TotalAmount;
              max_percent = 100;
              max_debit = t_bill.PayedAmount;
            } else if (
              acc.bill.Descriptor === BillLinkedTypeDescriptor.BillWithManyLinks
            ) {
              const t_bill = acc.bill as BillWithManyLinks;
              total_amount = t_bill.LinkAmount;
              max_amount = t_bill.LinkAmount;
              max_percent = t_bill.LinkPercent;
              max_debit = t_bill.PayedAmount;
            }
          }

          return {
            percent: +roundTo(max_percent, 4),
            amount: +roundTo(max_amount, 6),
            debit: max_debit,
            maxAmount: total_amount,
            limitAmount: +roundTo(max_amount, 6),
            maxDebit: max_debit,
            maxPercent: max_percent,
            bill: acc.bill,
            billRowType: acc.billRowType,
            canEditAmounts:
              (max_amount > 0 || max_percent > 0) &&
              (!this.isEditMode || this.isEditing),
            canEditDebits:
              max_debit > 0 && (!this.isEditMode || this.isEditing),
            canBeDeleted: true,
            nonExistent: !acc.isPreloaded,
            movement: {
              Items: [] /* this.theModel.positions.map((pos: PositionLine) => {
            return {
              Id: pos.Id,
              VendorCode: pos.pos_with_vcode[0].Instance?.StringValue,
              NameParameters: [],
              Note: '',
              MeasureUnit: pos.MeasureUnit,
              ItemQuantity: pos.qty,
              SingleItemPrice: pos.PriceType.Id === StorageItemPriceType.SetByUser
                  ? pos.price
                  : 0,
              TotalAmount: pos.amount,
              PriceType: pos.PriceType
          }), */,
              MovementType: this.createType,
              Id: this.existingMovementId || 0,
              VendorCode: "",
              Details: this.theModel.comment,
              Files: [],
              Date: new Date(),
              SourceStorage: this.storage.storagesWithItems.find(
                (s: CommonEntity) => s.Id === this.theModel.from,
              ),
              ReceiverStorage: this.storage.storagesWithItems.find(
                (s: CommonEntity) => s.Id === this.theModel.to,
              ),
            } as StorageItemMovementInFinances,
          } as ConnectionLine;
        }),
    );
  }

  async blockAccount(billId: number): Promise<boolean> {
    const store = useEntityStore();

    const e = store.getEntity(billId, LockedEntityType.Bill);
    if (e) {
      console.log("Есть в кэше:", e);
    } else {
      const result = await store.addEntity({
        id: billId,
        type: LockedEntityType.Bill,
        title: "",
      });

      if (!result.ok) {
        console.log({
          type: "negative",
          message: result.error,
        });
      } else {
        console.log({
          type: "positive",
          message: "Счёт успешно добавлен в кэш!",
        });
      }

      return result.ok
    }
    return true;
  }

  async blockPosition(posId: number): Promise<boolean> {
    const store = useEntityStore();

    const e = store.getEntity(posId, LockedEntityType.StorageItem);
    if (e) {
      console.log("Есть в кэше:", e);
    } else {
      const result = await store.addEntity({
        id: posId,
        type: LockedEntityType.StorageItem,
        title: "",
      });

      if (!result.ok) {
        console.log({
          type: "negative",
          message: result.error,
        });
      } else {
        console.log({
          type: "positive",
          message: "Счёт успешно добавлен в кэш!",
        });
      }

      return result.ok
    }
    return true;
  }

  async unblockAccount(billId: number) {
    const store = useEntityStore();

    const e = store.getEntity(billId, LockedEntityType.Bill);
    if (e) {
      console.log("Убираем из кэша счёт:", e);
      store.removeEntity(billId, LockedEntityType.Bill);
    }
  }

  async unblockPosition(posId: number) {
    const store = useEntityStore();

    const e = store.getEntity(posId, LockedEntityType.StorageItem);
    if (e) {
      console.log("Убираем из кэша позицию:", e);
      store.removeEntity(posId, LockedEntityType.StorageItem);
    }
  }

  async unblockAll() {
    const store = useEntityStore();
    console.log("Очистка кэша:");
    store.clearAll();
  }

  get additionEnabled(): boolean {
    if (this.currentPosId > 0) {
      return (
        this.theModel?.positions.findIndex(
          (pos: PositionLine) => pos.id == this.currentPosId,
        ) < 0
      );
    } else if (this.isIncome) {
      return !isInstanceContainerEmpty(this.parameters[1]);
    }
    return false;
  }

  get isPositionInputEmpty(): boolean {
    return isInstanceContainerEmpty(this.parameters[1]);
  }

  get canCreateWithoutBills(): boolean {
    return this.storage.storageAccess?.CanWrite && this.storage.storageAccess?.CanCreateIncomeWithoutBill;
  }

  get canEditIncome(): boolean {
    return this.storage.storageAccess?.CanWrite && this.storage.storageAccess?.CanEditExistingIncome;
  }

  get canEditMovementCommentByAuthor(): boolean {
    if (!this.isEditMode) return true;
    const creatorId = Number(this.existingMovementCreatorId ?? 0);
    const changerId = Number(this.rootstore?.oldAPIUID ?? 0);
    return creatorId > 0 && changerId > 0 && creatorId === changerId;
  }

  get canEditMovementComment(): boolean {
    return !!this.CanWrite && this.canEditMovementCommentByAuthor;
  }

  private async saveMovementCommentIfNeeded(): Promise<boolean> {
    if (!this.isEditMode || !this.existingMovementId) return true;
    if (!this.canEditMovementCommentByAuthor) return true;

    const newText = this.existingMovementComment || "";
    const shouldSave = newText !== this.movementCommentAtOpen || this.tids.length > 0;
    if (!shouldSave) {
      this.lastCommentCaretPosition = 0;
      return true;
    }

    const request: StorageDetailsEditRequest = {
      ElementId: this.existingMovementId,
      Value: newText,
      UsedDetailsTemplates: [...this.tids],
    };
    const res = await this.storage_move.editMovementDetails(request);
    if (!res?.response_ok) {
      return false;
    }

    // Метод возвращает итоговую строку, её и держим как актуальный текст.
    this.existingMovementComment = res.data?.Value ?? newText;
    this.movementCommentAtOpen = this.existingMovementComment;
    this.theModel.comment = this.existingMovementComment;
    this.tids.splice(0);
    this.lastCommentCaretPosition = 0;
    return true;
  }

  get actionButtonDisableReason(): string {
    if (this.isLoading) return this.$t('reason_loading');
    if ((!this.isEditMode || this.isEditing) && !this.allEntitiesLockedByUs) return this.$t('reason_entities_not_locked');
    if (this.isEditMode && this.isIncome && !this.canEditIncome) return this.$t('reason_no_edit_permission');
    if (this.isEditMode && !this.isEditing) return '';
    if (this.theModel.positions.length === 0) return this.$t('reason_no_positions');
    if (this.theModel.positions.some((p: PositionLine) => p.qty <= 0)) return this.$t('reason_zero_quantity');
    if (!this.canCreateWithoutBills && this.positionsTotal <= 0) return this.$t('reason_zero_total');
    if (this.isTransfer && this.theModel.from === this.theModel.to) return this.$t('reason_same_storage');
    if (this.isIncome && !this.sumsEqualForCreation && !(this.canCreateWithoutBills && this.accountsTotal === 0)) { console.log('[sums mismatch]', 'accounts:', this.accountsTotal, 'positions:', this.positionsTotal); return `${this.$t('reason_sums_not_equal')}: ${this.accountsTotal} ≠ ${this.positionsTotal}`; }
    return '';
  }

  get CanWrite(): boolean {
    return !this.readOnly && this.storage.storageAccess?.CanWrite;
  }

  get addButtonHint() {
    if (!this.additionEnabled) {
      if (
        this.theModel.positions.findIndex(
          (pos: PositionLine) => pos.id == this.currentPosId,
        ) > -1
      ) {
        return this.$t('position_already_exists');
      }
    } else {
      if (this.currentPosId > 0) {
        return this.$t('select_position');
      } else {
        return this.$t('create_and_select_position');
      }
    }
    return "";
  }

  // +++ метод кнопки "Добавить позицию" +++
  async addPositionClick() {
    if (!this.parameters || !this.parameters.length) {
      return;
    }

    if (!this.additionEnabled) {
      return;
    }

    const pos_copy = _.cloneDeep(this.parameters);
    let lastIncomePrice = 0;

    if (this.currentPosPriceType === StorageItemPriceType.LastIncome) {
      lastIncomePrice = this.currentPosPrice;
    } else {
      const plasti: NumericResponse =
        await this.storage_pos.getPriceByLastIncome(this.currentPosId);
      lastIncomePrice = plasti.Value;
    }

    if (!this.currentPosId && pos_copy[0].Instance) {
      pos_copy[0].Instance.StringValue = this.$t('new_fem');
    }

    this.modelValue = reactive({
      ...this.theModel,
      positions: [
        ...this.theModel.positions,
        {
          id: this.currentPosId || 0, //this.theModel.positions.length,
          qty: 0,
          amount: 0,
          price: this.currentPosPrice,
          priceByLastIncome: lastIncomePrice,
          MeasureUnit:
            this.storage_pos?.measureUnits?.Hints[
              this.currentPosUnit
                ? this.storage_pos?.measureUnits?.Hints.findIndex(
                    (el: CommonEntity) => el.Id === this.currentPosUnit,
                  )
                : 0
            ],
          PriceType:
            this.currentPosPriceType === StorageItemPriceType.LastIncome
              ? {
                  Name: this.$t('price_last_receipt'),
                  Id: StorageItemPriceType.LastIncome,
                }
              : {
                  Name: this.$t('set_by_user'),
                  Id: StorageItemPriceType.SetByUser,
                },
          pos: [pos_copy[1]],
          // isIncome - strip storage field; otherwise there is no storage field in the end
          pos_with_vcode: this.isIncome ? pos_copy.splice(0, pos_copy.length - 1) : pos_copy,
          storagesWithQuantities: this.currentPosStorages,
          new_p: !this.currentPosId,
        } as PositionLine,
      ],
    });

    if (this.currentPosId) {
      const locked = await this.blockPosition(this.currentPosId);
      if (!locked) {
        this.theModel.positions[this.theModel.positions.length-1].blocked_by_other = true;
      }
    }

    this.resetTemplate();
  }

  // Слушатель на window, а не на карточке, потому что фокус бывает в body, например после
  // закрытия попапа селекта с полем поиска. Фаза всплытия, чтобы поля внутри окна
  // по-прежнему обрабатывали Esc первыми.
  // Обработавший Esc внутри окна ставит preventDefault, и окно тогда не закрывается. Одной
  // проверки ownsEscape мало: к моменту всплытия до window Vue успевает перерисовать,
  // и закрытая подсказка уже пропала из DOM
  onEscKeydown(e: KeyboardEvent) {
    if (e.key !== "Escape" || e.defaultPrevented) {
      return;
    }
    const card = (this.$refs.cardRootRef as ComponentPublicInstance | undefined)?.$el as HTMLElement | undefined;
    if (!ownsEscape(card ?? null)) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    this.handleEsc();
  }

  handleEsc() {
    // console.log("Нажата клавиша ESC, перехватываем...");

    if (this.isEditing) {
      // Условие не выполнено: меняем режим, не закрываем
      // console.log("Условие не выполнено, меняем режим.");
      this.isEditing = false;
      this.existingMovementComment = this.movementCommentAtOpen;
      this.tids.splice(0);
      this.lastCommentCaretPosition = 0;
      // Диалог остается открытым благодаря persistent и preventDefault на событии
    } else {
      // Условие выполнено: разрешаем закрытие
      // console.log("Условие выполнено, закрываем диалог.");
      this.close();
    }
  }

  async actionButtonClick() {
    if (!this.isEditMode) {
      switch (this.createCompoundType) {
        case V2StorageItemMovementType.In:
          this.createIncomeClick();
          break;
        case V2StorageItemMovementType.Out:
          this.createExpenseClick();
          break;
        case V2StorageItemMovementType.Inner:
          this.createTransferClick();
          break;
        default:
          break;
      }
    } else if (!this.isEditing && this.isIncome) {
      // map existing bills connections
      for (let bi = 0; bi < this.tmp_accounts.length; bi++) {
        const binfo = (await this.finStore.getInfoCBill(
          this.tmp_accounts[bi].bill.Id,
        )) as BillInfo;
        if (binfo && binfo.Connections) {
          (this.tmp_accounts[bi].bill as any).Connections = _.cloneDeep(
            binfo.Connections,
          );
          if (binfo.Connections && binfo.Connections.length) {
            // Максимумы считаем по остальным привязкам, исключая текущую
            const other_connections = binfo.Connections.filter(
              (conn) =>
                !(
                  conn.Descriptor ===
                    BillConnectionWithValuesTypeDescriptor.Income &&
                  (conn as BillConnectionToItemIncomeWithValues).Income.Id ===
                    this.existingMovementId
                ),
            );

            // recalc max amounts
            let connections_sum = 0;
            let max_percent = 100;
            let max_amount = 0;
            let max_debit = 0;

            for (let ind = 0; ind < other_connections.length; ind++) {
              connections_sum += other_connections[ind].AbsoluteAmount;
              max_percent -= other_connections[ind].AmountPercent;
            }

            max_amount = binfo.CalculatedAmount - connections_sum;
            max_debit =
              binfo.PayedAmount > connections_sum
                ? binfo.PayedAmount - connections_sum
                : 0;

            const conn_el = this.entity_store.accounts.find(
              (stacc: ConnectionLine) =>
                stacc.bill?.Id === this.tmp_accounts[bi].bill.Id,
            ) as ConnectionLine;

            if (conn_el) {
              conn_el.maxAmount = binfo.CalculatedAmount;
              conn_el.limitAmount = +roundTo(+max_amount, 6);
              conn_el.maxDebit = +max_debit;
              conn_el.maxPercent = +roundTo(+max_percent, 4);

              if (conn_el.amount > +conn_el.limitAmount) {
                conn_el.amount = +conn_el.limitAmount;
              }
              if (conn_el.debit > +max_debit) {
                conn_el.debit = +max_debit;
              }
              conn_el.canEditAmounts =
                conn_el.limitAmount > 0 || conn_el.maxPercent > 0;
              conn_el.canBeDeleted = false;
              conn_el.canEditDebits = max_debit > 0;
            }
          }
        }
      }

      for (let accb = 0; accb < this.theModel.positions.length; accb++) {
        if (this.theModel.positions[accb].id > 0) {
          const locked = await this.blockPosition(this.theModel.positions[accb].id);
          if (!locked) {
            this.theModel.positions[accb].blocked_by_other = true;
          }
        }
      }

      for (let accb = 0; accb < this.tmp_accounts.length; accb++) {
        this.blockAccount(this.tmp_accounts[accb].bill.Id);
      }

      this.tids.splice(0);
      this.lastCommentCaretPosition = 0;
      this.isEditing = true;
    } else {
      switch (this.createCompoundType) {
        case V2StorageItemMovementType.In:
          this.editIncomeClick();
          break;
        case V2StorageItemMovementType.Out:
          this.isEditing = false;
          break;
        case V2StorageItemMovementType.Inner:
          this.isEditing = false;
          break;
        default:
          break;
      }
    }
  }

  async editIncomeClick() {
    // console.log(this.entity_store.accounts);

    // update Connections field in case current one prices changed
    const store_accs = this.entity_store.accounts as ConnectionLine[];
    for (
      let store_acc_idx = 0;
      store_acc_idx < store_accs.length;
      store_acc_idx++
    ) {
      if (
        store_accs[store_acc_idx].bill !== undefined &&
        !store_accs[store_acc_idx].nonExistent
      ) {
        const acc_bill = store_accs[store_acc_idx]
          .bill as BillSearchedWithConnections;
        for (
          let acc_conn_idx = 0;
          acc_conn_idx < acc_bill.Connections.length;
          acc_conn_idx++
        ) {
          if (
            acc_bill.Connections[acc_conn_idx].Descriptor ===
              BillConnectionWithValuesTypeDescriptor.Income &&
            (
              acc_bill.Connections[
                acc_conn_idx
              ] as BillConnectionToItemIncomeWithValues
            ).Income.Id === this.existingMovementId
          ) {
            acc_bill.Connections[acc_conn_idx].AbsoluteAmount =
              store_accs[store_acc_idx].amount; // decimal!
            acc_bill.Connections[acc_conn_idx].AmountPercent =
              store_accs[store_acc_idx].percent; // double
            acc_bill.Connections[acc_conn_idx].PayedAmount =
              store_accs[store_acc_idx].debit; // decimal!
          }
        }
      }
    }

    const request: StorageItemIncomeEditRequest = {
      IncomeId: this.existingMovementId,
      Items: this.theModel.positions
        .filter((pos: PositionLine) => pos.id)
        .map((pos: PositionLine) => {
          return {
            ItemId: pos.id,
            Quantity: pos.qty,
            SingleItemPrice:
              // pos.PriceType.Id === StorageItemPriceType.SetByUser
              // ?
              pos.price,
            //: 0,
          } as ExistingStorageItemForMovementCreation;
        }),
      Bills: [
        ...(this.entity_store.accounts as ConnectionLine[])
          .filter((acc: ConnectionLine) => /* acc.amount && */acc.bill !== undefined)
          .map((acc: ConnectionLine) => {
            return {
              BillId: acc.bill?.Id,
              Connections: [
                ...((acc.bill as BillSearchedWithConnections)?.Connections ||
                  []),
                ...(acc.nonExistent
                  ? [
                      {
                        Id: acc.conn_id && acc.conn_id > 0 ? acc.conn_id : -1,
                        AbsoluteAmount: acc.amount, // decimal!
                        AmountPercent: acc.percent, // double
                        PayedAmount: acc.debit, // decimal!
                        Descriptor:
                          BillConnectionWithValuesTypeDescriptor.Income,
                      } as BillConnectionWithValues,
                    ]
                  : []),
              ],
            } as BillConnectionWithValuesEditAsker;
          }),
        ...this.deleted_accounts.map((acc: ConnectionLine) => {
          return {
            BillId: acc.bill?.Id,
            Connections:
              (acc.bill as BillSearchedWithConnections)?.Connections.filter(
                (conn) =>
                  !(
                    conn.Descriptor ===
                      BillConnectionWithValuesTypeDescriptor.Income &&
                    (conn as BillConnectionToItemIncomeWithValues).Income.Id ===
                      this.existingMovementId
                  ),
              ) || [],
          } as BillConnectionWithValuesEditAsker;
        }),
      ],
      ExistingPayments: this.tmp_payments
        .filter((b) => b.bill != undefined && b.bill.Id > 0)
        .map((p) => p.bill?.Id || 0),
      NewPayments: this.tmp_payments
        .filter((b) => b.bill != undefined && b.bill.Id <= 0)
        .map((p) => {
          const bill = p.bill as BillLinkedBase;
          return {
            OwnerEntityId: this.existingMovementId,
            Amount: bill.TotalAmount,
            Number: bill.Number,
            Note: bill.Note,
            Currency: bill.Currency,
            CurrencyRate: bill.Rate,
            Date: bill.Date,
            Type: bill.Type,
          } as PaymentCreateRequest;
        }),
    };

    const res = await this.storage_move.editStorageIncome(request);
    if (res.response_ok) {
      const noteSaved = await this.saveMovementCommentIfNeeded();
      if (!noteSaved) {
        return;
      }
      /* this.close(); */ this.isEditing = false;
      this.entity_store.accounts = reactive([]);
      this.preloadExistingMovement();
      this.storage.getStoragesWithItems();
    }
  }

  async createIncomeClick() {
    if (!this.theModel.to) {
      return;
    }

    // console.log(this.theModel.positions)

    this.isLoading = true;
    try {
      const request = {
        ExistingItems: this.theModel.positions
          .filter((pos: PositionLine) => !pos.new_p && pos.id)
          .map((pos: PositionLine) => {
            return {
              ItemId: pos.id,
              Quantity: pos.qty,
              SingleItemPrice:
                // pos.PriceType.Id === StorageItemPriceType.SetByUser
                // ?
                pos.price,
              // : 0,
            } as ExistingStorageItemForMovementCreation;
          }), // Существующие позиции в движении. ExistingStorageItemForMovementCreation
        NewItems: this.theModel.positions
          .filter((pos: PositionLine) => pos.new_p)
          .map((pos: PositionLine) => {
            return {
              ItemContainer: {
                Containers: mapFilledContainerFromInstance(pos.pos),
                MeasureUnitId: pos.MeasureUnit.Id,
                Details: "",
                Files: [],
                PriceType: pos.PriceType.Id,
                Price:
                  pos.PriceType.Id === StorageItemPriceType.SetByUser
                    ? pos.price
                    : 0,
                UsedDetailsTemplates: this.tids,
              },
              Quantity: pos.qty,
              SingleItemPrice:
                // pos.PriceType.Id === StorageItemPriceType.SetByUser
                //  ?
                pos.price,
              //  : 0,
            } as NewStorageItemForMovementCreation;
          }), // Новые позиции в движении.

        Bills: (this.entity_store.accounts as ConnectionLine[])
          .filter((acc: ConnectionLine) => /* acc.amount && /*/ acc.bill !== undefined)
          .map((acc: ConnectionLine) => {
            return {
              BillId: acc.bill?.Id,
              Connections: [
                ...((acc.bill as BillSearchedWithConnections)?.Connections ||
                  []),
                {
                  Id: -1,
                  AbsoluteAmount: acc.amount, // decimal!
                  AmountPercent: acc.percent, // double
                  PayedAmount: acc.debit, // decimal!
                  Descriptor: BillConnectionWithValuesTypeDescriptor.Income,
                } as BillConnectionWithValues,
              ],
            } as BillConnectionWithValuesEditAsker;
          }), // Счета, привязки значащие. BillConnectionWithValuesEditAsker[]
        ExistingPayments: this.tmp_payments
          .filter((b) => b.bill != undefined && b.bill.Id > 0)
          .map((p) => p.bill?.Id || 0), // Платежки, привязки значащие.
        NewPayments: this.tmp_payments
          .filter((b) => b.bill != undefined && b.bill.Id <= 0)
          .map((p) => {
            const bill = p.bill as BillLinkedBase;
            return {
              OwnerEntityId: -1,
              Amount: bill.TotalAmount,
              Number: bill.Number,
              Note: bill.Note,
              Currency: bill.Currency,
              CurrencyRate: bill.Rate,
              Date: bill.Date,
              Type: bill.Type,
            } as PaymentCreateRequest;
          }),

        Projects: this.theModel.projects.map((p) => p.Id), // Проекты, привязка информационная.
        Files: [], // Привязанные файлы.
        ReceiverStorage: this.theModel.to, // Склад - приемник.
        Details: this.theModel.comment, // Заметка.
        UsedDetailsTemplates: this.tids, // Использованные шаблоны заметки.
      } as StorageItemIncomeCreateRequest;

      // возвращает Id нового движения
      const newMovementPosId = (
        await this.storage_move.createStorageIncome(request)
      )?.Id;
      if (newMovementPosId > 0) {
        // Загружаем все файлы из буфера по очереди (или через Promise.all)
        const uploadPromises = this.pendingFiles.map((item) => {
          // возвращает Id загруженного и привязанного файла
          return this.storage_move.addFileToMovement(
            item.file,
            newMovementPosId,
          );
        });

        await Promise.all(uploadPromises);

        this.isLoading = false;
        this.close();
        // Очищаем буфер после успеха
        this.pendingFiles.splice(0);
        this.tids.splice(0);
      }
    } catch (e) {
      alert(this.$t('error_saving'));
    } finally {
      localStorage.setItem("last_selected_move_to", "" + this.theModel.to);
      this.isLoading = false;
      this.storage.getStoragesWithItems();
    }
  }

  async createExpenseClick() {
    if (!this.theModel.from) {
      return;
    }

    this.isLoading = true;
    try {
      const request = this.getBaseMovementRequest();
      const newMovementPosId = (
        await this.storage_move.createStorageExpense(request)
      )?.Id;
      if (newMovementPosId > 0) {
        // Загружаем все файлы из буфера по очереди (или через Promise.all)
        const uploadPromises = this.pendingFiles.map((item) => {
          // возвращает Id загруженного и привязанного файла
          return this.storage_move.addFileToMovement(
            item.file,
            newMovementPosId,
          );
        });

        await Promise.all(uploadPromises);

        this.isLoading = false;
        this.close();
        // Очищаем буфер после успеха
        this.pendingFiles.splice(0);
        this.tids.splice(0);
      }
    } catch (e) {
      alert(this.$t('error_saving'));
    } finally {
      localStorage.setItem("last_selected_move_from", "" + this.theModel.from);
      this.isLoading = false;
      this.storage.getStoragesWithItems();
    }
  }

  async createTransferClick() {
    if (!this.theModel.from || !this.theModel.to) {
      return;
    }
    this.isLoading = true;
    try {
      let request = this.getBaseMovementRequest();
      request.ReceiverStorage = this.theModel.to;
      const newMovementPosId = (
        await this.storage_move.createStorageTransfer(request)
      )?.Id;
      if (newMovementPosId > 0) {
        // Загружаем все файлы из буфера по очереди (или через Promise.all)
        const uploadPromises = this.pendingFiles.map((item) => {
          // возвращает Id загруженного и привязанного файла
          return this.storage_move.addFileToMovement(
            item.file,
            newMovementPosId,
          );
        });

        await Promise.all(uploadPromises);

        this.isLoading = false;
        this.close();
        // Очищаем буфер после успеха
        this.pendingFiles.splice(0);
        this.tids.splice(0);
      }
    } catch (e) {
      alert(this.$t('error_saving'));
    } finally {
      localStorage.setItem("last_selected_move_from", "" + this.theModel.from);
      localStorage.setItem("last_selected_move_to", "" + this.theModel.to);
      this.isLoading = false;
      this.storage.getStoragesWithItems();
    }
  }

  // base request object for expenses and transfers
  getBaseMovementRequest(): StorageItemExpenditureMovementCreateRequest {
    return {
      Items: this.theModel.positions
        .filter((pos: PositionLine) => pos.id)
        .map((pos: PositionLine) => {
          return {
            ItemId: pos.id,
            Quantity: pos.qty,
            SingleItemPrice: pos.price,
          } as ExistingStorageItemForMovementCreation;
        }), // Существующие позиции в движении. ExistingStorageItemForMovementCreation

      Bills: (this.entity_store.accounts as ConnectionLine[])
        .filter(
          (acc: ConnectionLine) => /* acc.amount &&*/ acc.bill !== undefined,
        )
        .map((acc: ConnectionLine) => {
          return acc.bill?.Id;
        }), // Счета, привязки значащие. BillConnectionWithValuesEditAsker[]

      Project: this.theModel.projects.length
        ? this.theModel.projects[0].Id
        : null, // Проект, привязка информационная.
      Files: [], // Привязанные файлы.
      SourceStorage: this.theModel.from,
      Details: this.theModel.comment, // Заметка.
      UsedDetailsTemplates: this.tids, // Использованные шаблоны инфо.
    } as StorageItemExpenditureMovementCreateRequest;
  }

  recalcTotals() {
    /* hook when connection values recalc happens */
  }

  // money display value formatting
  money(n: number) {
    return new Intl.NumberFormat(intlLocale(), {
      // style: "currency",
      // currency: "RUB",
      minimumFractionDigits: 0, // Не показывать нули, если дробной части нет
      maximumFractionDigits: 4,
    }).format(n || 0);
  }

  chooseAndUploadFile() {
    if (this.$refs.fileInputStorage) {
      // @ts-ignore
      this.$refs.fileInputStorage.click();
    }
  }

  @Emit("attach-file")
  async attachFileForMovementAdd(event: Event) {
    const target = event.target as HTMLInputElement;
    if (!target.files) return;

    const selected = Array.from(target.files).map((f) => ({
      tempId: Math.random().toString(36).slice(2),
      file: f,
      name: f.name,
    }));

    this.pendingFiles.push(...selected);
    target.value = ""; // сброс инпута

    // если позиция уже существует, то сразу же загружаем файл
    if (this.isEditMode) {
      this.isLoading = true;
      try {
        // 1. Загружаем все файлы из буфера по очереди (или через Promise.all)
        const uploadPromises = this.pendingFiles.map((item) => {
          // возвращает Id загруженного и привязанного файла
          return this.storage_move
            .addFileToMovement(item.file, this.existingMovementId)
            .then((r: SingleIdResponse) => {
              return {
                Id: r.Id,
                Name: item.name,
              } as CommonEntity;
            });
        });

        const newFiles = await Promise.all(uploadPromises);

        // 2. Формируем итоговый массив ID (старые + только что загруженные)
        this.attachedFiles = reactive([...this.attachedFiles, ...newFiles]);

        this.isLoading = false;

        // Очищаем буфер после успеха
        this.pendingFiles.splice(0);
      } catch (e) {
        alert(this.$t('error_saving'));
      } finally {
        this.isLoading = false;
      }
    }
  }

  // Удаление локального (еще не загруженного) файла
  removePending(tempId: string) {
    if (this.isLoading) {
      return;
    }
    this.pendingFiles.splice(
      this.pendingFiles.findIndex((f) => f.tempId === tempId),
      1,
    );
  }

  @Emit("download-file")
  DownloadFile(file: CommonEntity, event: Event) {
    if (this.auxstore) {
      this.auxstore.downloadFile(file.Id, file.Name);
    }
  }

  @Emit("delete-file")
  async deleFileFromMovementAdd(fileId: string) {
    if (this.isLoading) {
      return;
    }
    try {
      await this.storage_move.deleteFileFromMovement(fileId);
      this.attachedFiles.splice(
        this.attachedFiles.findIndex((f) => f.Id === fileId),
        1,
      );
    } catch (e) {
      console.error(this.$t('error_deleting_file'), e);
    }
  }
}
</script>

<style lang="scss" scoped>
.movement-accounts-selector {
  :deep(.q-separator) {
    margin-top: 4px !important;
  }
}

/* Блоки */

/* Кнопки добавления */
.rcd__add-btn {
  background: none;
  border: none;
  color: var(--link);
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.rcd__add-btn:hover {
  text-decoration: underline;
}

.rcd__add-icon {
  width: 16px;
  height: 16px;
  fill: currentColor;
  margin-right: 4px;
}

.rcd__chip-container {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.rcd__chip {
  background: #f1f1f1;
  padding: 6px 12px;
  border-radius: 18px;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
}

.rcd__file-table {
  width: 100%;
  border-collapse: collapse;
}

.rcd__file-table th {
  text-align: left;
  padding: 8px 12px;
  border-bottom: 1px solid var(--line);
}

.rcd__file-table td {
  padding: 8px 12px;
  border-bottom: 1px solid var(--line);
}

.summary {
  display: flex;
  justify-content: flex-start;
  gap: $vertical-gap;
  flex-direction: column;
}

.summary__label {
  text-align: end;
  color: var(--muted);
  white-space: nowrap;
}

.movement-comment-existing {
  white-space: pre-wrap;
  color: #4d4d4d;
}

.comment-tpl-trigger {
  display: inline-flex;
  line-height: 0;
}

.add-pos-info {
  margin-top: 6px;
}

.white-dialog {
  background: rgba(255, 255, 255, 1);
  /* Убедитесь, что это белый фон */
}

.acctab-left-panel {
  padding: 10px;
}

.white-card {
  background: #ffffff;
  /* Белый фон для содержимого */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* Легкая тень для выделения */
}

.summary__hint {
  color: var(--muted);
  font-size: 12px;
  text-align: end;
  color: $accent;
  white-space: nowrap;
}

.green-text {
  color: $primary;
  font-weight: 500;
}

.inp {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  font-size: 14px;
}

.inp:focus {
  border-color: var(--accent);
}

.icon-btn {
  background: transparent;
  border: 0;
  color: var(--danger);
  cursor: pointer;
}

.icon-btn:hover {
  color: var(--danger);
  background: rgba(211, 47, 47, 0.1);
}
</style>
